import { Injectable, Injector } from '@angular/core';
import { Vendor } from '../entities/vendor';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Observable } from 'rxjs/Observable';
import { FormatUtils } from '../../shared/_utils/services/formatUtils';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class VendorService extends BaseCrudService<Vendor> {

  public uri = '/api/vendor/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance VendorService');
  }

  buildSentence(entity?: Vendor, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.firstLastName ? 'firstLastName'
          + QueryOperator.Contain + entity.firstLastName
          + QueryOperator.Split : QueryOperator.Empty
      );
      query = query.concat(
        entity.secondLastName ? 'secondLastName'
          + QueryOperator.Contain + entity.secondLastName
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.type && entity.type.code) {
        query = query.concat(
            entity.type.code ? 'type.code'
                + QueryOperator.Equal + entity.type.code
                + QueryOperator.Split : QueryOperator.Empty
        );
      };
      if (entity.type && entity.type.set1) {
        query = query.concat(
            entity.type.set1 ? 'type.set1'
                + QueryOperator.Equal + entity.type.set1
                + QueryOperator.Split : QueryOperator.Empty
        );
      };
      if (entity.type && entity.type.set2) {
        query = query.concat(
            entity.type.set2 ? 'type.set2'
                + QueryOperator.Equal + entity.type.set2
                + QueryOperator.Split : QueryOperator.Empty
        );
      };
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  getSequenceCode(): Observable<string> {
    const url = this.rutaServidor + this.uri + 'maxCode/';
    return this.httpClient.get<any>(url)
      .pipe(
        map(response => {
          // debugger;
          const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 10);
          const sequence = (parseInt(code, 10)) + 1;
          return FormatUtils.padLeftZero(sequence, 10);
        }),
        tap(response => {
         //console.log(response);
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/vendor.service.ts